import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CustomerInformation, DeliveryMethod, PaymentMethod } from './apiCustomerSliceTypes'

export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.config.API_URL,
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || '';
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId);
      }

      return headers
    },
  }),
  endpoints: builder => ({
    getInformationList: builder.query<CustomerInformation[], number>({
      query: id_page => `/suppliers/v1/customers/list?page=${id_page}`,
    }),
    getDeliveryMethods: builder.query<DeliveryMethod[], number>({
      query: customerId => `/suppliers/v1/customers/${customerId}/delivery-methods`,
    }),
    fetchPaymentMethods: builder.query<PaymentMethod[], number>({
      query: customerId => `/suppliers/v1/customers/${customerId}/payment-methods`,
    }),
  }),
})

export const { useGetInformationListQuery, useGetDeliveryMethodsQuery, useFetchPaymentMethodsQuery } = customerApi
